const translation = {
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    'Home': 'Home',
    'About': 'About',
    'Features': 'Features',
    'Stats': 'Stats',
    'Process': 'Process',
    'Contact': 'Contact',

    'Full Name': 'Full Name',
    'Email Address': 'Email Address',
    'Phone Number': 'Phone Number',
    'How can we help you?': 'How can we help you?',

    'i_agree_to_the': 'I agree to the',
    'Privacy Policy': 'Privacy Policy',
    'and': 'and',
    'Terms of Service': 'Terms of Service',

    'Send Message': 'Send Message',
    'Sending...': 'Sending...',

    'Services': 'Services',
    'Web Design': 'Web Design',
    'Web Development': 'Web Development',
    'Cloud Services': 'Cloud Services',
    'App Development': 'App Development',
    'Business Consulting': 'Business Consulting',
    'Digital businesses': 'Digital Businesses',

    'Company': 'Company',
    'Portfolio': 'Portfolio',
    'Apps': 'Apps',
    'Websites': 'Websites',
    'Business models': 'Business Models',

    'Connect': 'Connect',
    'Instagram': 'Instagram',

    'Language': 'Language',
    'Open menu': 'Open menu',
    'Close menu': 'Close menu',

    'Know more': 'Know more',
    'No projects available': 'No projects available',

    'Project not found': 'Project not found',
    'We could not find the information for this project.': 'We could not find the information for this project.',
    'Back to home': 'Back to home',

    'DANTRIX PRO / PROJECT': 'DANTRIX PRO / PROJECT',
    'CASE STUDY': 'CASE STUDY',

    '01 / PROJECT': '01 / PROJECT',
    'BEHIND THE PROJECT': 'BEHIND THE PROJECT',
    'Every solution starts by understanding the business, its needs and the goals it wants to achieve.': 'Every solution starts by understanding the business, its needs and the goals it wants to achieve.',
    'LET’S TALK ABOUT YOUR PROJECT': 'LET’S TALK ABOUT YOUR PROJECT',

    'DANTRIX PRO / NEXT STEP': 'DANTRIX PRO / NEXT STEP',
    'DO YOU HAVE AN IDEA IN MIND?': 'DO YOU HAVE AN IDEA IN MIND?',
    'We can analyze your project and develop a solution adapted to what your business needs.': 'We can analyze your project and develop a solution adapted to what your business needs.',

    'Business services': 'Business services',

    'Connect with us': 'Connect with us',
    'home': 'home'
};

export { translation };